import { createFileRoute } from "@tanstack/react-router";

import { ComplianceTaskList } from "@/components/compliance/ComplianceTaskList";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { FEATURES } from "@/lib/features";

export const Route = createFileRoute("/_authenticated/compliance/")({
  component: CompliancePage,
});

function CompliancePage() {
  return (
    <FeatureGate
      feature={FEATURES.COMPLIANCE_TASKS}
      featureName="Compliance tasks"
    >
      <ComplianceTaskList />
    </FeatureGate>
  );
}
